import { Component } from '@angular/core';

@Component({
  selector: 'app-passport-table',
  templateUrl: './passport-table.component.html',
  styleUrls: ['./passport-table.component.css']
})
export class PassportTableComponent {

  uid: string;
  tableData;
  passportData;
  tableItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  origPassportData: any;


  ngAfterViewInit() {
  }

  displayTable(body: any) {
    this.passportData = body;
    let color = 'black';
    this.uid = body.uid;
    this.tableData = body.result;

  }

  unchooseTr() {
    if (!this.tableData) return;
    for (let item of this.tableData) {
      item.chosen = false;
    }
  }



  itemFocusout() {

  }

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;


  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    this.unchooseTr();
    this.tableData = null;
  }
  downloadImg() {
    const imgBase64 =     `data:image/png;base64, ${this.passportData.imgBase64}`;
    const link = document.createElement('a');
    link.href = imgBase64;
    link.download = 'passport.png';
    link.click();
  }  
}
